<template>
  <b-container fluid>
    <b-row>
      <b-col cols="8">
        <b-card class="leaders-cart">
          <h4 class="leaders-title">{{ ls_Leaders }}</h4>
          <b-media
            v-for="(leader, index) in leaderList"
            :key="index"
            no-body
            vertical-align="bottom"
            class="leader">
            <b-media-aside vertical-align="center" class="leader-thumbnail">
              <img class="leader-avatar" :src="leader.thumbnailUrl" alt="placeholder" />
            </b-media-aside>
            <b-media-body class="leader-description">
              <h5 class="leader-tool leader-name">{{ leader.leaderName }}</h5>
              <p class="leader-tool leader-ship">
                {{ leader.leadership }}
              </p>
              <p class="leader-tool leader-mobile">
                {{ leader.mobile }}
              </p>
              <p class="leader-tool leader-email">
                <b-link>
                  {{ leader.email }}  
                </b-link>
              </p>
            </b-media-body>
          </b-media>
        </b-card>
      </b-col>
      <b-col cols="4">
        <sidebar-nav
          :menuTitle="ls_Menu"
          :menuList="leaderMenuList"
          :currentMenu="currentMenu">
        </sidebar-nav>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import SidebarNavigation from "@/components/navigation/SidebarNavigation.vue";

export default {
  data() {
    return {
      leaderList: []
    };
  },

  computed: {
    host() {
      return this.$store.state.host;
    },
    menuList() {
      let list = [];
      if (this.$store.state.navigationList.length > 0) {
        list = this.$store.state.navigationList.filter(
          n => n.url === "/about/us"
        )[0].childList;
      }

      return list;
    },

    currentMenu() {
      return this.menuList.filter(m => this.$route.path.includes(m.url))[0];
    },

    ls_Menu() {
      return this.$store.state.languagePack.ls_Menu;
    },

    ls_Leaders() {
      return this.$store.state.languagePack.ls_Leaders;
    },

    leaderMenuList() {
      let leaderMenus = [];
      if (this.menuList.length > 0) {
        this.menuList.forEach(function(menu) {
          leaderMenus.push({
            url: menu.url,
            target: menu.target,
            menuTitle: menu.title
          });
        });
      }
      return leaderMenus;
    }
  },

  created() {
    this.getLeaderList();
  },

  methods: {
    getLeaderList() {
      let fd = new FormData();
      fd.append("language", this.$route.params.ln);
      this.$http
        .post(this.host + "/api/qazlatyn/getleaderlist", fd)
        .then(result => {
          if (result.status === 200) {
            if (result.body.status === "success") {
              this.leaderList = result.body.data;
            } else {
              // console.log(result.body.message);
            }
          } else {
            // console.log('Err');
          }
        });
    }
  },

  watch: {
    $route(newVal, val) {
      if (val.params.ln !== newVal.params.ln) {
        this.getLeaderList();
      }
    }
  },

  components: {
    "sidebar-nav": SidebarNavigation
  },

  metaInfo() {
    return {
      title: "Leaders"
    };
  }
};
</script>

<style lang="scss" scoped>
.leaders-cart {
  border-radius: 0;

  .leaders-title {
    color: #008496;
    font-size: 1.25rem;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid #008496;
  }

  .leader {
    padding: 1rem 0;

    .leader-thumbnail {
      padding-right: 1rem;

      .leader-avatar {
        border-radius: 0.25rem;
        height: 10rem;
      }
    }

    .leader-description {
      .leader-tool {
        margin-bottom: 0.5rem;
      }

      // .leader-name {
      //   margin-bottom: 1.5rem;
      // }

      // .leader-ship {

      // }

      // .leader-mobile {

      // }

      // .leader-email {

      // }
    }
  }
}
</style>
